var $a8b6912f9795b6b1$exports = {};
$a8b6912f9795b6b1$exports = {
    "actions": `Veiksmai`,
    "hideButtonLabel": `Rodyti ma\u{17E}iau`,
    "noTags": `N\u{117}ra`,
    "showAllButtonLabel": (args, formatter)=>`Rodyti visk\u{105} (${formatter.number(args.tagCount)})`
};


export {$a8b6912f9795b6b1$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
